'use strict';

function CompanyGdprContactsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/gdpr-contacts/:contactId', {}, {
    'update':  {
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyGdprContactsService', ['$resource', 'config', CompanyGdprContactsService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/gdpr/contacts/CompanyGdprContactsService.js
// module id = 358
// module chunks = 0